<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
    <span *ngIf="data.title === 'templateCategory'">Add Artifactory Category</span>
    <span *ngIf="data.title === 'templateType'">Add Artifactory Types</span>
    <span *ngIf="data.title === 'complianceType'">Add Compliance Type</span>
    <span *ngIf="data.title === 'AddRegion'">Add New Region</span>
    <span *ngIf="data.title === 'AddCountry'">Add New Country</span>
    <span *ngIf="data.title === 'AddCity'">Add New City</span>
    <span *ngIf="data.title === 'AddOfficeLocation'">Add New Location</span>
    <i class="fa fa-times cursor-pointer" (click)="close()"></i>
</h1>

<div mat-dialog-content *ngIf="data.title=='templateCategory'" class="popup-content">
    <span class="labelName">Artifactory Category Name <sup class="requiredStar">*</sup></span>
    <input type="text" class="form-control" placeholder="Enter Category Name"
        [class.is-invalid]="flag&&!data.template ? 'is-invalid' : ''" (keyup)="AddTemplateCategory($event)">
    <div *ngIf="er1&&data.template.length>0" class="error">Only Alphabets are allowed</div>
    <div *ngIf="flag&&!data.template">
        <span class="error">Artifactory Name is required</span>
    </div>
    <span class="labelName">Artifactory Description <sup class="requiredStar">*</sup></span>
    <!-- <label class="mt-2" style="margin-bottom: 0px;"><b>Artifactory Description  <sup class="requiredStar">*</sup></b> </label> -->
    <textarea id="message" rows="4" cols="50" class="form-control"
        [ngClass]="flag&&!data.templateDescription ? 'is-invalid' : ''" placeholder="Enter Artifactory Description"
        (keyup)="AddTemplateDesc($event)"></textarea>
    <div *ngIf="er2&&data.templateDescription.length>0" class="error">Only Alphabets are allowed</div>
    <div *ngIf="flag&&!data.templateDescription">
        <span class="error">Artifactory Description is required
        </span>
    </div>


</div>

<div mat-dialog-content *ngIf="data.title=='templateType'" class="popup-content">
    <textarea rows="4" cols="50" (keyup)="AddSubTemplateCategory($event)" class="form-control"
        [ngClass]="flag&&!data.templateTypes ? 'is-invalid' : ''"
        placeholder="Enter Artifactory Types(Ex:MBR Artifactories, QBR Artifactories)"></textarea>
    <div *ngIf="er3&&data.templateTypes.length>0" class="error">Only Alphabets are allowed</div>
    <div *ngIf="flag&&!data.templateTypes">
        <span class="error">Artifactory Type is required
        </span>
    </div>

</div>

<div mat-dialog-content *ngIf="data.title=='AddRegion'" class="popup-content">
    <textarea rows="4" cols="50" (keyup)="AddRegion($event)" class="form-control"
        [ngClass]="flag&&!data.region ? 'is-invalid' : ''" placeholder="Enter New Region"></textarea>
    <div *ngIf="er5&&data.region.length>0" class="error">Only Alphabets are allowed</div>
    <div *ngIf="flag&&!data.region">
        <span class="error">Region is required
        </span>
    </div>

</div>

<div mat-dialog-content *ngIf="data.title=='complianceType'" class="popup-content">
    <textarea rows="4" cols="50" (keyup)="AddComplianceType($event)" class="form-control"
        [ngClass]="flag&&!data.compliance ? 'is-invalid' : ''" placeholder="Enter Compliance Type"></textarea>
    <div *ngIf="er4&&data.compliance.length>0" class="error">Only Alphabets are allowed</div>
    <div *ngIf="flag&&!data.compliance">
        <span class="error">Compliance Type is required
        </span>
    </div>

</div>

<div mat-dialog-content *ngIf="data.title=='AddCountry'" class="popup-content">
    <textarea rows="4" cols="50" (keyup)="AddCountry($event)" class="form-control"
        [ngClass]="flag&&!data.country ? 'is-invalid' : ''" placeholder="Enter New Country"></textarea>
    <div *ngIf="er5&&data.country.length>0" class="error">Only Alphabets are allowed</div>
    <div *ngIf="flag&&!data.country">
        <span class="error">Country is required
        </span>
    </div>

</div>
<div mat-dialog-content *ngIf="data.title=='AddCity'" class="popup-content">
    <textarea rows="4" cols="50" (keyup)="AddCity($event)" class="form-control"
        [ngClass]="flag&&!data.city ? 'is-invalid' : ''" placeholder="Enter Compliance Type"></textarea>
    <div *ngIf="er6&&data.city.length>0" class="error">Only Alphabets are allowed</div>
    <div *ngIf="flag&&!data.city">
        <span class="error">City is required
        </span>
    </div>

</div>

<div mat-dialog-content *ngIf="data.title=='AddOfficeLocation'" class="popup-content">
    <textarea rows="4" cols="50" (keyup)="AddOfficeLocation($event)" class="form-control"
        [ngClass]="flag&&!data.location ? 'is-invalid' : ''" placeholder="Enter Location Name"></textarea>
    <div *ngIf="er7&&data.location.length>0" class="error">Only Alphabets are allowed</div>
    <div *ngIf="flag&&!data.location">
        <span class="error">Location is required
        </span>
    </div>

</div>
<div mat-dialog-actions class="justify-content-end popup-buttons">
    <button class="btn custom_btn inverted_btn_base " (click)="close()">Cancel</button>
    <button *ngIf="data.title=='templateCategory'" class="btn custom_btn primary_btn_base ml-2"
        (click)="closeDialog()">Submit</button>
    <button *ngIf="data.title=='templateType'" class="btn custom_btn primary_btn_base ml-2"
        (click)="closeDialog1()">Submit</button>
    <button *ngIf="data.title=='complianceType'" class="btn custom_btn primary_btn_base ml-2"
        (click)="closeDialog2()">Submit</button>
    <button *ngIf="data.title=='AddRegion'" class="btn custom_btn primary_btn_base ml-2"
        (click)="closeDialog3()">Submit</button>
    <button *ngIf="data.title=='AddCountry'" class="btn custom_btn primary_btn_base ml-2"
        (click)="closeDialog4()">Submit</button>
    <button *ngIf="data.title=='AddCity'" class="btn custom_btn primary_btn_base ml-2"
        (click)="closeDialog5()">Submit</button>
    <button *ngIf="data.title=='AddOfficeLocation'" class="btn custom_btn primary_btn_base ml-2"
        (click)="closeDialog6()">Submit</button>

</div>